import { Controller } from 'stimulus';

import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['modal'];

  connect() {
    this.listener = document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        this.close();
      }
    });
  }

  submit(event) {
    event.preventDefault();
    let form = event.target;
    let params = new FormData(form);
    let title = document.getElementsByClassName('notifications-box')[0];

    Rails.ajax({
      dataType: 'script',
      type: 'POST',
      url: `${form.action}`,
      data: params,
      success: (data) => {
        let message = data.alert_message || 'Ваш запрос отправлен на обработку. В ближайшее время документ поступит на указанную почту.';
        this.showAlert(message, title, form, 'is-info');
        this.scrollToTop();
      },
      error: (data) => {
        let message = data.alert_message || 'Отправка запроса не удалась. Попробуйте повторить попытку позднее.';
        this.showAlert(message, title, form, 'is-warning');
        this.scrollToTop();
      }
    });
    if (document.querySelector('#new_special_prices_file_modal input[type="submit"]')) {
      document.querySelector('#new_special_prices_file_modal input[type="submit"]').disabled = false;
    }
  }

  notification_submit(event) {
    event.preventDefault();
    let form = event.target;
    let params = new FormData(form);
    let title = document.getElementsByClassName('notifications-box')[0];

    Rails.ajax({
      dataType: 'script',
      type: 'POST',
      url: `${form.action}`,
      data: params,
      success: (data) => {
        this.close();
        form.querySelector('input[type="submit"]').disabled = false;
        this.scrollToTop();
      },
      error: (data) => {
        let message = data.alert_message || 'Отправка запроса не удалась. Попробуйте повторить попытку позднее.';
        this.showAlert(message, title, form, 'is-warning');
        this.scrollToTop();
      }
    });
  }

  disconnect() {
    document.removeEventListener('keyup', this.listener);
  }

  open() {
    if (document.querySelector('#new_special_prices_file_modal input[type="submit"]')) {
      document.querySelector('#new_special_prices_file_modal input[type="submit"]').disabled = false;
    };
    this.modalTarget.classList.add('is-active');
  }

  close() {
    if (document.querySelector('#new_special_prices_file_modal input[type="submit"]')) {
      document.querySelector('#new_special_prices_file_modal input[type="submit"]').disabled = false;
    };
    document.documentElement.classList.remove('is-clipped');
    this.modalTarget.classList.remove('is-active');
  }

  showAlert(message, title, form, style) {
    let x = `<div class="section notifications" data-controller="layout--notification">
               <div class="container">
                 <div class="notification ${style} notifications__notification">
                   <button class="delete" data-action="layout--notification#close"></button>
                   ${message}
                 </div>
               </div>
             </div>`;
    title.insertAdjacentHTML('beforeend', x);
    this.close();
    form.querySelector('input[type="submit"]').disabled = false;
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
